import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { styled, Theme } from "@mui/material/styles"
import { FormControlLabel } from "@mui/material"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Checkbox from "components/atoms/Checkbox"
import UserCard from "components/molecules/UserCard"

type FriendsListProps = {
  closeFriendUsers: UserDto[];
  nonCloseFriendUsers: UserFollowDto[];
  onChange: (ids: number[]) => void;
}

export default function CloseFriendsForm(props: FriendsListProps) {
  const { closeFriendUsers, nonCloseFriendUsers, onChange } = props

  const [closeFriendIds, setCloseFriendIds] = useState<number[]>([])

  const { t } = useTranslation()

  useEffect(() => {
    const friendIds = closeFriendUsers.map(user => user.id)
    setCloseFriendIds(friendIds)
  }, [closeFriendUsers])

  useEffect(() => {
    onChange(closeFriendIds)
  }, [closeFriendIds])

  function handleOnCloseFriendCheckChange(event: React.SyntheticEvent, userId: number) {
    // @ts-ignore
    const isChecked = event.target.checked
    if (isChecked) {
      setCloseFriendIds(prevState => [...prevState, userId])
    } else {
      setCloseFriendIds(prevState => prevState.filter(id => id !== userId))
    }
  }

  function handleOnNonCloseFriendCheckChange(event: React.SyntheticEvent, userId: number) {
    // @ts-ignore
    const isChecked = event.target.checked
    if (isChecked) {
      setCloseFriendIds(prevState => [...prevState, userId])
    } else {
      setCloseFriendIds(prevState => prevState.filter(id => id !== userId))
    }
  }

  return (
    <Stack gap="8px" margin="58px 0">
      {closeFriendUsers.length > 0 ? <Stack gap="8px" overflow="scroll" marginBottom="16px">
        {closeFriendUsers.map((user, index) => (
          <UserRow
            key={index}
            control={<Checkbox variant="select"/>}
            checked={closeFriendIds && closeFriendIds.includes(user.id)}
            label={
              <UserCard
                id={user?.id}
                handle={user?.handle}
                name={user?.name}
                avatar={user?.avatar}
                avatarWidth={"46px"}
                skipDefaultNavigation={true}
              />
            }
            onChange={(event) => handleOnCloseFriendCheckChange(event, user.id)}
          />
        ))}
      </Stack> : null}

      {nonCloseFriendUsers.length > 0 ? <>
        <Title>{t("connections.otherFollowers")}</Title>

        <Stack gap="8px" overflow="scroll">
          {nonCloseFriendUsers.map((user, index) => (
            <UserRow
              key={index}
              control={<Checkbox variant="select"/>}
              checked={closeFriendIds && closeFriendIds.includes(user.id)}
              label={
                <UserCard
                  id={user?.id}
                  handle={user?.handle}
                  name={user?.name}
                  avatar={user?.avatar}
                  avatarWidth={"46px"}
                  skipDefaultNavigation={true}
                />
              }
              onChange={(event) => handleOnNonCloseFriendCheckChange(event, user.id)}
            />
          ))}
        </Stack>
      </> : null}
    </Stack>
  )
}

type UserRowProps = {
  theme?: Theme;
}

const UserRow = styled(FormControlLabel)(({ theme }: UserRowProps) => ({
  width: "100%",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
  margin: 0,
  padding: "0 8px"
}))

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.1rem",
  fontWeight: 500,
  color: theme.palette.gray["14"],
  margin: "0 8px"
}))
